import React from 'react';
import { Team } from '../components/team/Team';
export default function TeamPage() { return <Team />; }
